import { hasPermission } from "../../Config/permissions.js";

// Plan D1/D17: the enrollment button is a user-type check only, deliberately
// not permission-gated, so distributor users need no permission changes.
export const canSubmitAccountEnrollment = (user) =>
  user?.Type === "Distributor" || user?.Type === "Admin";

// Plan D4/D17: the Approvals tab sits on top of the Approvals page's existing
// Admin/Authorizer gate and additionally requires manage_accounts.add.
export const canReviewAccountEnrollment = (user) =>
  (user?.Type === "Admin" || user?.Type === "Authorizer") &&
  hasPermission(user, "manage_accounts.add");

// Plan D10: distributor users submit for their own distributor and cannot
// change it; admins pick one.
export const isDistributorLockedForEnrollment = (user) =>
  user?.Type === "Distributor";

export const getLockedDistributorId = (user) =>
  isDistributorLockedForEnrollment(user) && user?.DistributorID
    ? Number(user.DistributorID)
    : null;
